<template>
  <v-card
      class="transparent mb-7"
      v-model="list"
      flat
      width="100%"
  >
    <v-card
        flat
        v-for="element in list"
        :key="element.order"
        color="transparent"
    >
      <div>
        <v-card
            elevation="5"
            class="rounded-xl pr-10 mb-7"
        >
          <v-icon
              class="right-close-btn ml-5 right"
              color="primary"
              @click="remove(element)"
          >
            mdi-close
          </v-icon>

          <slot v-if="element.item.type == 'video'" name="video" v-bind:video="element.item.data"></slot>

          <slot v-if="element.item.type == 'scorm'" name="scorm" v-bind:scorm="element.item.data"></slot>
        </v-card>
      </div>
    </v-card>
  </v-card>
</template>

<script>

export default {
  name: "ResourceResultCard",
  methods: {
    remove(item) {
      const newItems = this.items;
      const index = this.items.indexOf(item.item);
      if(index >= 0) {
        newItems.splice(index, 1);
      }
      this.reorder(newItems);
    },
  },
  computed: {
    list: {
      get() {
        return this.items.map((item, index) => {
          return { item, order: index + 1, fixed: false };
        });
      },
      set(newOrder) {
        const formattedResources = [];
        newOrder.forEach(function(resource) {
          formattedResources.push(Object.assign({}, resource.item));
        });
        this.reorder(formattedResources);
      },
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>